module.exports = __webpack_public_path__ + "static/media/arrow-up-white.0a04929d.svg";